import { render, staticRenderFns } from "./Yjpz.vue?vue&type=template&id=4342aee2&scoped=true&"
import script from "./Yjpz.vue?vue&type=script&lang=js&"
export * from "./Yjpz.vue?vue&type=script&lang=js&"
import style0 from "./Yjpz.vue?vue&type=style&index=0&id=4342aee2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342aee2",
  null
  
)

export default component.exports